/**
 * Client mirror of api/_artistPayment.cjs paymentLinkProvider — for inline
 * validation only; the API validates again.
 */
const MERCADO_PAGO_LINK_RE = /^https:\/\/([a-z0-9-]+\.)*(mercadopago\.com(\.mx)?|mpago\.(la|li))\//i;
const CLIP_LINK_RE = /^https:\/\/pago\.clip\.mx\/\S+$/i;

/** 'mercado_pago' | 'clip' | null */
export const paymentLinkProvider = (url) => {
  const value = typeof url === 'string' ? url.trim() : '';
  if (CLIP_LINK_RE.test(value)) return 'clip';
  if (MERCADO_PAGO_LINK_RE.test(value)) return 'mercado_pago';
  return null;
};
